import KineticHero from "@/components/KineticHero";
import RecentDiscoveries from "@/components/RecentDiscoveries";
import GlobalCatalogue from "@/components/GlobalCatalogue";
import PhotoPulseStrip from "@/components/PhotoPulseStrip";
import IdentifySighting from "@/components/AddSightingSimple";
import FeaturedStoriesStrip from "@/components/FeaturedStoriesStrip";
import EditorialMarquee from "@/components/EditorialMarquee";
import ManifestoChapters from "@/components/ManifestoChapters";
import EnvironmentalIndicators from "@/components/EnvironmentalIndicators";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";
import ClimateTimeline from "@/components/ClimateTimeline";
import ClimateStories from "@/components/ClimateStories";
import CommunityScience from "@/components/CommunityScience";
import BiodiversityGallery from "@/components/BiodiversityGallery";
import RegionCard from "@/components/RegionCard";
import PlacesGallery from "@/components/PlacesGallery";
import WorldMap from "@/components/WorldMap";

export default function Home() {
  return (
    <>
      <KineticHero />
      <RecentDiscoveries />
      <FeaturedStoriesStrip />
      <PhotoPulseStrip />
      <GlobalCatalogue />
      <EditorialMarquee />
      <ManifestoChapters />
      <EnvironmentalIndicators />
      <RegionCard />
      <EditorialMarquee terms={["EARTH · LIVING ARCHIVE", "SATELLITE · SENTINEL-2", "IPCC AR7 · 2028", "NDVI · 0.72 AVG", "REEF DEATH · +14%", "MONARCH · −22% YOY", "MANGROVE · +3.4% ASIA"]} />
      <BeforeAfterSlider />
      <ClimateTimeline />
      <ClimateStories />
      <PlacesGallery />
      <WorldMap />
      <BiodiversityGallery />
      <IdentifySighting />
      <div id="community"><CommunityScience /></div>
    </>
  );
}
